import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { DELETE } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { DELETE_MOTORBIKE, DELETE_MOTORBIKE_FAILURE, DELETE_MOTORBIKE_SUCCESS } from 'src/redux/motorbikesReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* DeleteMotorbikeFlow(action: { payload: string }): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/motorbikes/${action.payload}`
    yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: DELETE,
      params: {}
    })
    yield put(DELETE_MOTORBIKE_SUCCESS(action.payload))
  } catch (error) {
    yield put(DELETE_MOTORBIKE_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* DeleteMotorbikeSaga(): Generator<any, void, any> {
  yield takeLatest(DELETE_MOTORBIKE, DeleteMotorbikeFlow)
}
